/* eslint-disable react/prefer-stateless-function,no-unused-vars,react/no-unused-prop-types */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { t } from 'utils/translates';

import {
  changeDefaultQueryParams,
  changeStaticQueryParams,
  changeQueryParams,
  selectItemsIds,
  selectPagination,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';

import NoticeSetReadAllButton from './ActionsButtons/NoticeSetReadAllButton';

import NotificationsListItem from './NotificationsListItem';
import PaginationBlock from '../../../../../components/Common/Pagination/PaginationBlock/index';
import MediumPreLoader from '../../../../../components/Common/PreLoaders/MediumPreLoader';

const eventsUserNoticesCollectionRN =
  'eventsModule.collections.eventsUserNoticesCollection';

class NotificationsList extends Component {
  constructor(props) {
    super(props);
    this.props.changeDefaultQueryParams({
      page: '1'
    });
    this.props.changeStaticQueryParams({
      category_id: props.match.params.categoryId
    });
    this.props.sendRequest();
  }
  componentWillUpdate(nextPops) {
    if (
      nextPops.match.params.categoryId !== '' &&
      !_.isEqual(
        this.props.match.params.categoryId,
        nextPops.match.params.categoryId
      )
    ) {
      this.props.changeStaticQueryParams({
        category_id: nextPops.match.params.categoryId
      });
      this.props.changeQueryParams({ page: '1' });
      this.props.sendRequest();
    }
  }

  render() {
    if (this.props.requestState.inProgress) {
      return <MediumPreLoader />;
    }
    return (
      <React.Fragment>
        <div className="panel panel-default panel-heading_padding-large">
          <div className="panel-heading">
            <div className="media full-width">
              <div className="media-body media-middle full-width">
                <h1 className="panel-title">
                  <i className="fa fa-bell" /> {t('Уведомления')}
                </h1>
              </div>
              <div className="media-right media-middle text-overflow">
                <Link to={'/main/customize-notifications'}>
                  {t('Настройки')}
                </Link>
                {' / '}
                <NoticeSetReadAllButton />
              </div>
            </div>
          </div>
          {this.props.itemsIds.length > 0 ? (
            this.props.itemsIds.map(itemId => (
              <NotificationsListItem
                key={`NotificationsListItem${itemId}`}
                item={this.props.selectItemById(itemId)}
              />
            ))
          ) : (
            <div className="panel-notify panel-notify-alone text-center">
              {t('Уведомления не найдены')} :-(
            </div>
          )}
        </div>
        <PaginationBlock
          paginationData={this.props.pagination}
          handlePageClick={pageNumber => {
            this.props.changeQueryParams({ page: pageNumber });
            this.props.sendRequest();
          }}
        />
      </React.Fragment>
    );
  }
}

NotificationsList.defaultProps = {
  match: {
    params: { categoryId: '' }
  }
};

NotificationsList.propTypes = {
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeStaticQueryParams: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,

  match: PropTypes.shape({
    params: PropTypes.shape({
      categoryId: PropTypes.string
    })
  })
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, eventsUserNoticesCollectionRN, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeStaticQueryParams: queryParams =>
    dispatch(changeStaticQueryParams(props.listReduceName, queryParams)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/NotificationsList.js